module.exports = "./img/6fef4c145a5b8f0d881cc1be040d9b8b.jpg";